// Template: resources/views/account/invoices.blade.php

import ApiClient from '../support/ApiClient';

export default {

    name: "Invoices",

    data() {
        return {
            invoices: null,
            showInvoiceModal: false,
            selectedInvoice: null,
            status: false,
            printStyleLink: null,
            api: {}
        }
    },

    computed: {
        selectedInvoiceCompanyAddress() {
            if (this.selectedInvoice == null) return;
            return [
                this.selectedInvoice.to.company.name,
                this.selectedInvoice.to.company.address,
                (this.selectedInvoice.to.company.zipCode || this.selectedInvoice.to.company.city) !== null
                    ? `${this.selectedInvoice.to.company.zipCode} ${this.selectedInvoice.to.company.city}`
                    : null,
                this.selectedInvoice.to.company.state,
                this.selectedInvoice.to.country
            ].filter(val => val !== null)
        }
    },

    mounted() {
        this.api = new ApiClient('store');
        this.getInvoices();
    },

    methods: {
        getInvoices() {
            this.api.get('invoices', data => {
                this.invoices = data.reverse();

                if (this.hasInvoiceHash()) {
                    this.openInvoiceModal(this.invoices.filter(invoice => invoice.id == this.getInvoiceIdFromHash())[0]);
                }
            });
        },

        openInvoiceModal(invoice) {
            this.selectedInvoice = invoice;
            this.showInvoiceModal = true;
            this.loadPrintStyle();
        },

        closeInvoiceModal() {
            this.selectedInvoice = {};
            this.showInvoiceModal = false;
            this.removePrintStyle();
        },

        downloadPdf(invoice) {
            // TODO: download request maybe?
            console.log(invoice.id);
        },

        print() {
            this.status = 'printing';
            window.print();
            setTimeout(() => {
                this.status = '';
            }, 500);
        },

        loadPrintStyle() {
            this.status = 'loading';

            let d = new Date();
            let printStyleLink = document.createElement('link');
            printStyleLink.rel = 'stylesheet';
            printStyleLink.type = 'text/css';
            printStyleLink.id = 'invoice-style';
            printStyleLink.href = `/assets/backend/css/invoice-print.css?id=${d.getMonth()+1}${d.getDate()}${d.getFullYear()}${d.getHours()}`;
            printStyleLink.addEventListener('load', () => {
                this.status = '';
            });

            this.printStyleLink = printStyleLink;
            document.querySelector('head').appendChild(printStyleLink);
        },

        removePrintStyle() {
            if (this.printStyleLink) this.printStyleLink.remove();
        },

        hasInvoiceHash() {
            return window.location.hash ? window.location.hash.includes('invoice') : false;
        },

        getInvoiceIdFromHash() {
            return /-(.*)/g.exec(window.location.hash)[1];
        }
    }
};
